import { useEffect, useState } from "react";

import { Checkbox } from "@/components/ui/inputs/Checkbox/Checkbox";

interface IProps {
  indeterminate?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

const TableCheckboxCell = ({ indeterminate, className, checked, onChange }: IProps) => {
  const [innerIndeterminate, setInnerIndeterminate] = useState(false);

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      setInnerIndeterminate(!checked && indeterminate);
    }
  }, [indeterminate, checked]);

  return (
    <div className="flex w-full cursor-pointer items-center p-3">
      <Checkbox
        isIndeterminate={innerIndeterminate}
        isSelected={!!checked}
        className={`${className} w-1 cursor-pointer`}
        onChange={onChange}
      />
    </div>
  );
};

export default TableCheckboxCell;
